import { createAsyncThunk } from '@reduxjs/toolkit'
import { get, post, put, remove } from '../services/crud'
import { ServiceConfig } from '../services/config'

import {
  ApiError,
  CreateLeadNoteBulkInput,
  CreateLeadNoteInput,
  GetLeadNotesInput,
  GetLeadNotesResponse,
} from './typings'
import { LeadNote } from '@user/components/Notes/typings'
import { toQueryString } from '@sales-center/common'

const baseUrl = `${ServiceConfig.baseAPIUrl}/LeadNote`

// GET LEAD NOTES
export const getLeadNotes = createAsyncThunk<
  GetLeadNotesResponse,
  GetLeadNotesInput,
  { rejectValue: ApiError }
>('leadNotes/get', async (model, thunkApi) => {
  const response = await get(
    `${baseUrl}/lead/${model.leadId}?includeExternal=true&${toQueryString(
      model.query || '',
    )}`,
  )

  if (response.ok) {
    const payload: GetLeadNotesResponse = await response.json()

    if (!!payload.items) {
      payload.items.forEach((note) => {
        note.createdDate = new Date(note.createdDate)
      })
    }

    payload.leadId = model.leadId

    return payload
  }
  return thunkApi.rejectWithValue((await response.json()) as ApiError)
})

// GET LEAD NOTE BY ID
export const getLeadNoteById = createAsyncThunk<
  LeadNote,
  number,
  { rejectValue: ApiError }
>('leadNote/getNoteById', async (id, thunkApi) => {
  const response = await get(`${baseUrl}/${id}`)

  if (response.ok) {
    const payload: LeadNote = await response.json()

    return {
      ...payload,
      createdDate: new Date(payload.createdDate),
    }
  }
  return thunkApi.rejectWithValue((await response.json()) as ApiError)
})

// DELETE LEAD NOTE BY ID
export const deleteLeadNote = createAsyncThunk<
  number,
  number,
  { rejectValue: ApiError }
>('leadNote/delete', async (id, thunkApi) => {
  const response = await remove(`${baseUrl}/${id}`)

  if (response.ok) return id
  return thunkApi.rejectWithValue(await response.json())
})

// CREATE LEAD NOTE
export const createLeadNote = createAsyncThunk<
  LeadNote,
  CreateLeadNoteInput,
  { rejectValue: ApiError }
>('leadNote/add', async (model, thunkApi) => {
  const response = await post(`${baseUrl}`, model)

  if (response.ok) {
    const payload: LeadNote = await response.json()

    return {
      ...payload,
      createdDate: new Date(payload.createdDate),
    }
  }
  return thunkApi.rejectWithValue((await response.json()) as ApiError)
})

// UPDATE LEAD NOTE
export const updateLeadNote = createAsyncThunk<
  LeadNote,
  CreateLeadNoteInput,
  { rejectValue: ApiError }
>('leadNote/update', async (model, thunkApi) => {
  const response = await put(`${baseUrl}`, model)

  if (response.ok) {
    const payload: LeadNote = await response.json()
    return {
      ...payload,
      createdDate: new Date(payload.createdDate),
    }
  }
  return thunkApi.rejectWithValue((await response.json()) as ApiError)
})

// CREATE BULK LEAD NOTE
export const createLeadNoteBulk = createAsyncThunk<
  { success: boolean },
  CreateLeadNoteBulkInput,
  { rejectValue: ApiError }
>('leadNote/bulkAdd', async (model, thunkApi) => {
  const response = await post(`${baseUrl}/bulkAdd`, model)

  if (response.ok) {
    return {
      success: true,
    }
  }
  return thunkApi.rejectWithValue((await response.json()) as ApiError)
})
